import { useSyncExternalStore } from 'react';
import type { RoomData } from '../messages';
import RoomStateStore, { reconnectingChanged, roomStateChanged } from '../RoomState';

// GameEvent.subscribe expects the full event callback type, but useSyncExternalStore
// provides a no-arg notifier. We wrap and cast to bridge the two APIs.
type RoomHandler = (room: RoomData | null) => void;
type ReconnectHandler = (reconnecting: boolean) => void;

function subscribe(callback: () => void): () => void {
  const handler: RoomHandler = () => callback();
  roomStateChanged.subscribe(handler);
  return () => roomStateChanged.unsubscribe(handler);
}

function subscribeReconnecting(callback: () => void): () => void {
  const handler: ReconnectHandler = () => callback();
  reconnectingChanged.subscribe(handler);
  return () => reconnectingChanged.unsubscribe(handler);
}

export function useIsHost(): boolean {
  return useSyncExternalStore(
    subscribe,
    () => RoomStateStore.isHost,
    () => RoomStateStore.isHost,
  );
}

export function useIsInRoom(): boolean {
  return useSyncExternalStore(
    subscribe,
    () => RoomStateStore.isInRoom,
    () => RoomStateStore.isInRoom,
  );
}

export function useMyPlayerId(): string | null {
  return useSyncExternalStore(
    subscribe,
    () => RoomStateStore.myPlayerId,
    () => RoomStateStore.myPlayerId,
  );
}

export function useReconnecting(): boolean {
  return useSyncExternalStore(
    subscribeReconnecting,
    () => RoomStateStore.reconnecting,
    () => false,
  );
}
